import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './AccountingIcon.module.scss';
export const AccountingSyncIcon = (props)=>{
    const { size = 'small', intent = 'success', prefix } = props, rest = _object_without_properties(props, [
        "size",
        "intent",
        "prefix"
    ]);
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles[size], styles[intent]),
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "".concat(prefix, "-").concat(intent),
        children: /*#__PURE__*/ _jsx("path", {
            d: "M22 12C22 17.52 17.52 22 12 22C6.48 22 3.11 16.44 3.11 16.44M3.11 16.44H7.63M3.11 16.44V21.44M2 12C2 6.48 6.44 2 12 2C18.67 2 22 7.56 22 7.56M22 7.56V2.56M22 7.56H17.56",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
